import React from "react";
import "./GoogleTrendDeepDive.scss";
import isEqual from "react-fast-compare";
import InterestOverTime from "../TwitterTrendDeepDive/InterestOverTime";
import GoogleTrendKpi from "./GoogleTrendKpi";
import GoogleTrendsContainerForGTrend from "./GoogleTrendsContainerForGTrend";
const GoogleTrendDeepDive = ({}) => {
  return (
    <>
      <div className="GoogleTrendDeepDive w-100 h-100">
        <div className="GoogleTrendDeepDive__kpi">
          <GoogleTrendKpi />
        </div>
        <div className="GoogleTrendDeepDive__trendline mb-sm-3">
          <div className="GoogleTrendDeepDive__trendline--overtime">
            <InterestOverTime />
          </div>
        </div>
        <div className="GoogleTrendDeepDive__trendreport">
          <GoogleTrendsContainerForGTrend />
        </div>
      </div>
    </>
  );
};
export default React.memo(GoogleTrendDeepDive, isEqual);
